import { useEffect,useState } from 'react';

import useIsFirstRender from '@/hooks/useIsFirstRender';
import useTranslations from '@/i18n/useTranslations';
import FormError from '@/shared-components/error/components/FormError';
import Text from '@/shared-components/text/components/Text';

import MainPictureCard from './components/MainPictureCard';
import UploadMainPicture from './components/UploadMainPicture';

import './index.css';

export default function MainPicture({ element, formError, setFormError, previewMode, fillWith, onChange, disabled = false,  }) {
  const t = useTranslations('common.forms.add_artwork');
  const [mainPictureFile, setMainPictureFile] = useState(fillWith); 
  const isFirstRender = useIsFirstRender();
  const resolvedError = Array.isArray(formError)
    ? formError.find((error) => error.element === element)
    : (formError?.element === element ? formError : null);

  useEffect(()=>{
    if(!isFirstRender) {
      if(!mainPictureFile?.loading) {
        onChange(mainPictureFile);
      } else {
        onChange(null);
      }
    }
  }, [mainPictureFile]);

  return (
    <>
      <h2 className="add-artwork-media-form__heading">
        {t('media.main_picture')}
      </h2>
      <div className={[
        "add-artwork-media-form__main-picture",
        disabled && "is-disabled",       // ⇐ añade la clase
      ].filter(Boolean).join(" ")}
      id={`${element}_error`}
      >
        {
          mainPictureFile ?
            <MainPictureCard
              previewMode={previewMode}
              mainPictureFile={mainPictureFile}
              setMainPictureFile={setMainPictureFile}
              disabled={disabled}
            />
            :
            <UploadMainPicture
              element={element}
              setFormError={setFormError}
              setMainPictureFile={setMainPictureFile}
              disabled={disabled}
            />
        }

        <FormError 
          error={resolvedError} 
          alternativeElement={mainPictureFile ? `${element}_error` : `${element}_button_error`} 
          element={element}
        />
      </div>
      <Text
        className="add-artwork-media-form__text"
        paragraph
        justify>
        {t('media.main_picture_description')}
      </Text>
    </>
  );
}
